<template>
    <div class="box">
        <Box :title="Title">
            <FacilityDetails v-if="!($route.params.Title=='巡检验收')" :data="Info" />
            <div class="borrow default">
                <p style="font-weight: 600;font-size: 4.5vw;">验收信息</p>
                <van-radio-group class='radiogroup' :key="index" v-for="(item,index) in radioArray" v-model="item.Checked"
                    direction="horizontal">
                    <span>{{item.text}}</span>
                    <van-radio v-for="(child,list) in item.content" checked-color="#4fa69e" :key="list" :name="list">{{child}}分</van-radio>
                </van-radio-group>
                <Field title="合计" :text="radioArray[0].Checked+radioArray[1].Checked+radioArray[2].Checked+radioArray[3].Checked+4"
                    type="text" />
                <Field title="验收人" :text="this.$UserInfo.UserName" type="text" />
                <Field title="验收时间" :text="this.$format(new Date,'YYYY-MM-DD')" type="text" />
                <Field title="验收意见" type='textarea' @onMessage='value=>Remark=value' />
            </div>
            <div style="margin-top:50px;"></div>
        </Box>
        <Footer button="提交验收" @change="change" />
    </div>
</template>

<script>
    import {
        RadioGroup,
        Radio
    } from 'vant';
    import Field from '@/components/field/field'
    import Box from '../../components/commonBox/commonBox'
    import Title from '../../components/commonTitle/commonTitle'
    import FacilityDetails from '../../components/facilityDetails/facilityDetails'
    import Footer from '../../components/footer/footer'
    export default {
        name: 'PrecautionreceivingDefault',
        components: {
            Box,
            Title,
            FacilityDetails,
            Footer,
            Field,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio
        },
        data() {
            return {
                Title:this.$route.params.Title,//标题
                pageState: this.$route.params.pageState, //预防、重点、巡检、保养使用此页面
                Info: {//满足主线程和消息进入
                    SSDH:this.$route.params.item.SSDH,
                    EquName:this.$route.params.item.SBMC||this.$route.params.item.EquName,
                    EquCode:this.$route.params.item.SBBH||this.$route.params.item.EquId||this.$route.params.item.KSBH,
                    Size:this.$route.params.item.SBXH || this.$route.params.item.Standards,
                    EquNumber:this.$route.params.item.SBXLH,
                    DepartmentName:this.$route.params.item.KSMC|| this.$route.params.item.DepName,
                },
                radioArray: [{
                        text: '服务态度',
                        Checked: 4,
                        content: [1, 2, 3, 4, 5]
                    },
                    {
                        text: '技术水平',
                        Checked: 4,
                        content: [1, 2, 3, 4, 5]
                    },
                    {
                        text: '相应时效',
                        Checked: 4,
                        content: [1, 2, 3, 4, 5]
                    },
                    {
                        text: '满意度',
                        Checked: 4,
                        content: [1, 2, 3, 4, 5]
                    }
                ],
                Remark: null, //验收意见
            }
        },
        mounted() {
        },
        methods: {
            change() {
                if (this.pageState === 1) { //预防验收
                    const data = {
                        JHDH: this.Info.OrderNo,
                        SSDH: this.Info.SSDH,
                        SBBH: this.Info.EquCode,
                        YSR: this.$UserInfo.UserId,
                        YSRQ: this.$format(new Date(), 'YYYY-MM-DD'),
                        FWTD: this.radioArray[0].Checked + 1,
                        JSSP: this.radioArray[1].Checked + 1,
                        XYSX: this.radioArray[2].Checked + 1,
                        MYD: this.radioArray[3].Checked + 1,
                        YSYJ: this.Remark,
                        DFLX: '1'
                    };
                    this.$get('api/YF/SetExamine', {
                        data: JSON.stringify(data),
                        SSDH: this.Info.SSDH,
                        SBBH: this.Info.EquCode,
                        STORE: this.$UserInfo.StoreCode
                    }).then(result => {

                        this.$Toast(result.Msg);
                        if (result.Status) {
                            setTimeout(x => {
                                this.$Bus.$emit('Message',this.Info.SSDH);
                                this.$router.back();
                            }, 2000)
                        }
                    })
                } else if (this.pageState === 2) { //巡检验收提交
                    this.$post('api/QualityControl/XJYS', {
                        STORE: this.$UserInfo.StoreCode,
                        data: {
                            SSDH: this.Info.SSDH,
                            SBBH: this.Info.EquCode,//此处设备编号也指巡检的科室编号
                            YSR: this.$UserInfo.UserId,
                            YSRQ: this.$format(new Date(), 'YYYY-MM-DD'),
                            FWTD: this.radioArray[0].Checked + 1,
                            JSSP: this.radioArray[1].Checked + 1,
                            XYSX: this.radioArray[2].Checked + 1,
                            MYD: this.radioArray[3].Checked + 1,
                            YSYJ: this.Remark,
                            DFLX: '3',
                        }
                    }).then(result => {
                        console.log(result);
                        if (result.Status) {
                            this.$Toast({
                                message:'验收成功!',
                                duration:2000,
                                onClose:()=>{
                                    this.$Bus.$emit('Message',this.Info.SSDH);
                                    this.$router.back();
                                }
                            });
                        } else this.$Toast('验收失败,请联系管理员!');
                    })
                } else if (this.pageState === 3) { //保养验收提交
                    this.$post('api/BY/BYYS', {
                        SSDH: this.Info.SSDH,
                        SBBH: this.Info.EquCode,
                        YSR: this.$UserInfo.UserId,
                        YSRQ: this.$format(new Date(), 'YYYY-MM-DD'),
                        FWTD: this.radioArray[0].Checked + 1,
                        JSSP: this.radioArray[1].Checked + 1,
                        XYSX: this.radioArray[2].Checked + 1,
                        MYD: this.radioArray[3].Checked + 1,
                        YSYJ: this.Remark,
                        DFLX: '6',
                        STORE: this.$UserInfo.StoreCode
                    }).then(result => {
                        if (result.Status) {
                            this.$Toast({
                                message:'验收成功!',
                                duration:2000,
                                onClose:()=>{
                                    this.$Bus.$emit('Message',this.Info.SSDH);
                                     this.$router.back();

                                }
                            });
                        } else this.$Toast('验收失败,请联系管理员!');
                    })
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .title {
        color: $TEXT-DARK-COLOR;
        font-size: 34px;
        font-weight: bold;
    }

    .default {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 34px 40px 0;
        box-sizing: border-box;
        margin-bottom: 20px;
    }

    .radiogroup {
        &>span {
            margin: 20px 0;
            width: 100%;
        }

        &>.van-radio {
            width: 20%;
            margin: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/precautionreceivingDefault/precautionreceivingDefault.vue